export default {
  namespaced: true,
  state: {
    data: [],
    fetching: true
  },
  mutations: {
    set (state, data) {
      state.data = data
    }
  },
  actions: {
    fetch ({ state, commit }) {
    }
  }
}
